import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import SubHeaders from '@/components/Headers/SubHeaders'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { generatePathDatacentral, paths } from '@/utils/path'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getAffiliateById } from '../../services'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import useTabs from '@/hooks/useTabs'
import { Tabs } from 'vnetwork-ui'
import { tabs } from './tabs'
import AddIcons from '@/icons/AddIcons'
import useAffiliatePolicyPermissions from '../../hooks/useAffiliatePolicyPermissions'

const Detail = () => {
    const { t } = useTranslation('affiliate')
    const { id } = useParams()
    const [searchParams] = useSearchParams()
    const activeTab = searchParams.get('tab') || 'overview'

    const [policyModalOpen, setPolicyModalOpen] = useState(false)
    const { canCreatePolicy } = useAffiliatePolicyPermissions()

    const {
        data: affiliate,
        renderState,
        refetch,
    } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.AFFILIATES, 'detail', id],
        queryFn: () => getAffiliateById(Number(id)),
    })

    const { TabProps, TabComponent } = useTabs({
        tabs: tabs({
            t,
            affiliate: affiliate?.result,
            affiliateId: Number(id),
            refetch,
            policyModalOpen,
            setPolicyModalOpen,
        }),
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    const actions =
        activeTab === 'policies' && canCreatePolicy
            ? [
                  {
                      icon: <AddIcons />,
                      label: t('add_policy'),
                      onClick: () => setPolicyModalOpen(true),
                  },
              ]
            : []

    return (
        <div>
            <SubHeaders
                actions={actions}
                breadcrumbs={[
                    {
                        path: paths.affiliatesList,
                        title: t('affiliate_manager'),
                    },
                    {
                        path: generatePathDatacentral(paths.affiliateDetail, {
                            id: id || '',
                        }),
                        title: affiliate?.result?.referrer_name || '',
                    },
                ]}
            />

            <div className="bg-white rounded-md mt-2">
                <Tabs {...TabProps} tabContainerClassName="pt-0" />
            </div>

            {TabComponent}
        </div>
    )
}

export default Detail
